import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL ?? '';
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY ?? '';

const explicitMocks = import.meta.env.VITE_USE_MOCKS === 'true';
const envMissing = !url || !anonKey;

/**
 * Mocks mode is enabled when:
 *   (a) VITE_USE_MOCKS=true is set explicitly, OR
 *   (b) the Supabase env vars are missing — fall back so the SPA still
 *       boots and shows the design instead of white-screening.
 * (b) emits a one-time console warning so the misconfiguration isn't silent.
 */
export const USE_MOCKS = explicitMocks || envMissing;

if (envMissing && !explicitMocks && typeof window !== 'undefined') {

  console.warn(
    '[ariel-dashboard] VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY are not set — falling back to mock data. Set both at build time to enable live mode.',
  );
}

let client: SupabaseClient | null = null;

export function getSupabase(): SupabaseClient {
  if (!client) {
    if (!url || !anonKey) {
      throw new Error('VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY are not set');
    }
    client = createClient(url, anonKey, {
      auth: { persistSession: true, autoRefreshToken: true },
    });
  }
  return client;
}
